var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { MainLayout } from '../../components/layouts/MainLayout';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { gdprDataSlice } from '../../store/gdprData/gdprData.slice';
import { useScript } from '../../hooks/useScript.hook';
import { useGAEventMeta } from '../../hooks/useGAEventMeta.hook';
import { GAService } from '../../services/GAService';
import { urlUtils } from '../../utils/url.utils';
import { useAudienceMarker } from '../../hooks/useAudienceMarker.hook';
import useEmotionStyles from '../../uikit/hooks/useEmotionStyles';
var styles = function () { return ({
    iframe: {
        height: 'calc(100vh - 80px)',
        minHeight: '400px',
        width: '100%',
        border: 'none',
    },
    pixel: {
        opacity: 0,
        width: '1px',
        height: '1px',
    },
}); };
var AUTH_PARAMS = {
    pid: '17103',
    wmid: '22',
    cpid: '2',
    prid: '51',
};
var mapStateToProps = function (state) { return ({
    placementId: initialDataSlice.selectors.getPlacementId(state),
}); };
function getCleanAudienceMarker(marker) {
    if (marker === null) {
        return null;
    }
    var cleanMarker = marker.replace(/_/g, '');
    if (/\d/.test(cleanMarker)) {
        return null;
    }
    return cleanMarker;
}
function getTrackingClickIdSubidSign(search) {
    var queryParams = new URLSearchParams(search);
    var gclid = queryParams.get('gclid');
    if (gclid !== null && gclid !== '') {
        return "gclid".concat(gclid);
    }
    var fbclid = queryParams.get('fbclid');
    if (fbclid !== null && fbclid !== '') {
        return "fbclid".concat(fbclid);
    }
    return '';
}
function makeSubid(cleanAudienceMarker, trackingClickIdSign) {
    if (cleanAudienceMarker === null) {
        return null;
    }
    return "".concat(cleanAudienceMarker).concat(trackingClickIdSign);
}
export var RawDrKleinPage = function (_a) {
    var placementId = _a.placementId;
    useScript('https://www.drklein.de/typo3conf/ext/hypo_gridelements/Resources/Public/JavaScript/GridElements/Drklein/app-container/app-container.js');
    var audienceMarker = useAudienceMarker({
        ignoreCampaign: true,
        ignorePlacementId: true,
    });
    var isMarketingCategoryGranted = useSelector(gdprDataSlice.selectors.isMarketingCategoryGranted);
    var cleanAudienceMarker = useMemo(function () {
        return getCleanAudienceMarker(audienceMarker);
    }, [audienceMarker]);
    var trackingClickIdSign = useMemo(function () {
        if (!isMarketingCategoryGranted || typeof window === 'undefined') {
            return '';
        }
        return getTrackingClickIdSubidSign(window.location.search);
    }, [isMarketingCategoryGranted]);
    var subid = useMemo(function () { return makeSubid(cleanAudienceMarker, trackingClickIdSign); }, [cleanAudienceMarker, trackingClickIdSign]);
    var gaEventMeta = useGAEventMeta();
    var ref = useRef(null);
    var handleIframeResize = useCallback(function (nextHeight) {
        if (ref.current === null) {
            return;
        }
        // equality to custom attribute "data-brandingLegalsHeight"
        var BRANDING_LEGALS_HEIGHT = 180;
        var prescisedHeight = Math.ceil(nextHeight) + BRANDING_LEGALS_HEIGHT;
        ref.current.style.height = "".concat(prescisedHeight, "px");
    }, []);
    var handlePostMessage = useCallback(function (_a) {
        var messageData = _a.data;
        if (messageData.event && messageData.event === 'DrK Baufilead') {
            return GAService.onLeadCreated(placementId, gaEventMeta);
        }
        if (!messageData || !messageData.type || !messageData.data) {
            return;
        }
        var type = messageData.type, data = messageData.data;
        if (type === 'drk-kontaktformular.iframe.resized' &&
            typeof data.height === 'number') {
            return handleIframeResize(data.height);
        }
    }, [placementId, gaEventMeta]);
    useEffect(function () {
        window.addEventListener('message', handlePostMessage);
        return function onUnmount() {
            window.removeEventListener('message', handlePostMessage);
        };
    }, []);
    var iframeUrl = useMemo(function () {
        return urlUtils.makeURLWithQuery('https://www2.finanzpartnernetz.de/go.cgi', __assign(__assign(__assign({}, AUTH_PARAMS), { wmid: '2590', target: 'DRK_baufi_iframe' }), (subid !== null && { subid: subid })));
    }, [subid]);
    var pixelUrl = useMemo(function () {
        return urlUtils.makeURLWithQuery('https://www2.finanzpartnernetz.de/go.cgi', __assign(__assign(__assign({}, AUTH_PARAMS), (subid !== null && { subid: subid })), { view: '1' }));
    }, [subid]);
    var cs = useEmotionStyles(styles);
    return (React.createElement(MainLayout, null,
        React.createElement(ClientOnlyContent, null,
            React.createElement("div", { ref: ref },
                React.createElement("iframe", { className: cs.iframe, frameBorder: "0", src: iframeUrl, title: "Baufinanzierungsantrag Dr. Klein", id: "drk-appcontainer" }),
                React.createElement("img", { className: cs.pixel, src: pixelUrl })))));
};
export var DrKleinPage = connect(mapStateToProps)(RawDrKleinPage);
